import React from 'react';
import './tableRanking.scss';
import useFormatParties from '../../dataProvider/hooks/useFormatParties';

const COMPARE_MUNICIPALITIES = new Set([
  '28079', // Madrid
  '08019', // Barcelona
  '08015', // Badalona
  '08101', // L'Hospitalet
  '08187', // Sabadell
  '48020', // Bilbao
  '11012', // Cádiz
  '35016', // Las Palmas de Gran Canaria
  '29067', // Málaga
  '29069', // Marbella
  '30030', // Murcia
  '07040', // Palma de Mallorca
  '20069', // San Sebastián
  '41091', // Sevilla
  '46250', // Valencia
  '47186', // Valladolid
  '01059', // Vitoria
  '50297', // Zaragoza
  '15078', // Santiago de Compostela
  '15030', // A Coruña
  '36057', // Vigo
  '45168' // Toledo
]);

const TableRanking = ({ currentData, pastData, place }) => {
  const partyFormats = useFormatParties(currentData, pastData);

  if (!partyFormats) {
    return <div>Loading</div>;
  }

  const isValid = !place ? true : COMPARE_MUNICIPALITIES.has(place);

  const partiesResult = partyFormats.filter(item => item.seats);

  return (
    <div className="tableRankingScrollContent">
      <div className="tableRankingScroll">
        <div className="tableRanking">
          <table summary="Escaños por partido.">
            <thead>
              <tr>
                <th className="partido" />
                <th className="year year_current">10-N</th>
                {isValid && <th className="year year_last">28-A</th>}
              </tr>
            </thead>
            <tbody>
              {partyFormats &&
                partiesResult &&
                partiesResult.map(party => (
                  <tr key={party.id}>
                    <td
                      className="partyName"
                      style={{ backgroundColor: party.partyColor }}
                    >
                      <h3 className="partyName_title">
                        {`${party.partyAcronym}${party.id === 43 ? ' *' : ''}`}
                      </h3>
                    </td>
                    <td className="partySeats partySeats_current">
                      {party.seats}
                    </td>
                    {isValid && (
                      <td className="partySeats partySeats_old">
                        <span className={party.symbolClassName}>
                          {Math.abs(party.difference)}
                        </span>
                      </td>
                    )}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
      <p className="table-legend">
        *Respecto al escaño obtenido por Compromís el 28-A
      </p>
    </div>
  );
};

export default TableRanking;
